<template>
  <el-select
    clearable
    :value="selectedCity"
    filterable
    placeholder="请选择城市"
    @change="changeCity"
    :style="customStyle"
    :disabled="disabled"
  >
    <el-option
      v-for="item in city_options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>
<script>
import { CITY_OPTIONS } from '@/utils/platform'
export default {
  name: 'CitySelect',
  computed: {
    selectedCity() {
      return this.value == null ? '' : String(this.value)
    },
    city_options() {
      return this.showAll ? [{ value: '', label: '全部' }, ...CITY_OPTIONS] : CITY_OPTIONS
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    showAll: {
      type: Boolean,
      default: true
    },
    customStyle: {
      type: String,
      default: 'width: 150px'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeCity(e) {
      this.$emit('input', e)
      this.$emit('onChange', e)
    }
  }
}
</script>
<style scoped lang="less"></style>
